import React from "react";
import { cn } from "utils/utils";

interface MapSkeletonProps {
  className?: string;
  searchBarClassName?: string;
  enableSearchBar?: boolean;
}

const MapSkeleton: React.FC<MapSkeletonProps> = ({
  className,
  searchBarClassName,
  enableSearchBar = true,
}) => {
  return (
    <div className={cn("rounded-box relative w-full", className)}>
      {enableSearchBar && (
        <div
          className={cn(
            "absolute left-0 right-0 top-4 z-50 mx-auto w-11/12 md:top-8 md:w-1/2 lg:w-2/5 xl:w-1/3",
            searchBarClassName
          )}
        >
          <div className="skeleton h-10 w-full"></div>
        </div>
      )}
      <div
        className={cn("rounded-box", className, "skeleton h-full w-full")}
      ></div>
    </div>
  );
};

export default MapSkeleton;
